(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentSupplierContractDeleteController', AgentSupplierContractDeleteController);

    AgentSupplierContractDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentSupplierContract'];

    function AgentSupplierContractDeleteController($uibModalInstance, entity, AgentSupplierContract) {
        var vm = this;

        vm.agentSupplierContract = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentSupplierContract.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
